const ChooseButton = ({ p, selected, onSelect, busy }) => (
  <button type="button" onClick={() => onSelect(p.id)} disabled={busy} aria-pressed={selected}
    className={`btn w-full ${selected ? "bg-gold text-ink hover:bg-gold-hover disabled:opacity-100" : "bg-rule/60 text-ink-soft hover:bg-rule"}`}
    style={{ transition: "background-color .3s ease, color .3s ease" }} data-testid={`price-${p.id}-select-btn`}>
    {busy && selected ? "Opening checkout" : p.join}
  </button>
);

export const PriceCard = ({ p, selected = false, onSelect, busy = false, children }) => (
  <div data-testid={`price-${p.id}`} data-selected={selected}
    className={`text-left rounded-2xl border bg-white p-6 flex flex-col ${selected ? "border-gold border-t-4" : "border-rule"}`}
    style={{ transition: "border-color .35s ease" }}>
    <div className="flex items-center justify-between gap-3">
      <p className="font-display text-xl text-charcoal">{p.title}</p>
      {p.badge && <span className="rounded-full bg-gold px-3 py-1 text-xs font-semibold text-ink" data-testid={`price-${p.id}-badge`}>{p.badge}</span>}
    </div>
    <p className="mt-2"><span className="font-display text-4xl text-charcoal">{p.price}</span>{p.unit && <span className="ml-1.5 text-sm text-ink-soft">{p.unit}</span>}</p>
    {p.tagline && <p className="mt-2 font-medium text-charcoal">{p.tagline}</p>}
    <ul className="mt-4 space-y-2 text-[15px] text-ink list-disc pl-5">
      {p.points.map((t) => <li key={t}>{t}</li>)}
    </ul>
    {(children || onSelect) && <div className="mt-auto pt-5">{onSelect ? <ChooseButton p={p} selected={selected} onSelect={onSelect} busy={busy} /> : children}</div>}
  </div>
);
